// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3jKSh","title":"Header_title__25n9S","side":"Header_side__rsW0M"};